import React from 'react'
import { Link }            from 'react-router-dom'
import { Grid, Container, Typography } from '@mui/material'
import CategoryCard from '../components/Category/CategoryCard'
import MiddlePiece from '../components/Category/MiddlePiece'
import StaffPicks from '../components/Category/StaffPicks'
import NewArrivals from '../components/Category/NewArrivals'
import Brands from '../components/Category/Brands'
import SEO from '../components/SEO'


// Example data
const CATEGORIES = [
  { title: 'T-shirt', image: '/Category-grid/T-shirt.png', overlayColor: 'green' },
  { title: 'Hoodie',   image: '/Category-grid/Hoodie.png',   overlayColor: 'orange' },
  { title: 'Pants', image: '/Category-grid/Pants-2.png', overlayColor: 'green' },
  { title: 'Hats',   image: '/Category-grid/Hat.png',   overlayColor: 'orange' },
  { title: 'Crewneck', image: '/Category-grid/Crew-neck.png', overlayColor: 'green' },
  { title: 'Others',   image: '/Category-grid/Other.png',   overlayColor: 'orange' },
]



export default function CategoryPage() {

  return (
    <>
        <SEO
          title="Shop Christian Clothing by Category | Holy Wear House"
          description="Browse Christian streetwear and faith-inspired apparel by category, including tees, hoodies, hats, and more from trusted Christian brands."
          keywords="christian clothing categories, faith-based apparel, christian streetwear, holy wear house categories"
          path="/categories"
          structuredData={[
            {
              '@context': 'https://schema.org',
              '@type': 'CollectionPage',
              name: 'Shop Christian Clothing by Category | Holy Wear House',
              description: 'Browse Christian streetwear and faith-inspired apparel by category, including tees, hoodies, hats, and more from trusted Christian brands.',
              url: 'https://holywearhouse.com/categories',
            },
            {
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: 'Home',
                  item: 'https://holywearhouse.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: 'Categories',
                  item: 'https://holywearhouse.com/categories',
                },
              ],
            },
            {
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              name: 'Categories',
              itemListOrder: 'Unordered',
              url: 'https://holywearhouse.com/categories',
              itemListElement: CATEGORIES.map((cat, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: cat.title,
                url: `https://holywearhouse.com/products?category=${encodeURIComponent(cat.title)}`,
              })),
            },
          ]}
        />
        <MiddlePiece />
        <StaffPicks />
        <NewArrivals />
       <Container>
              {/* Section Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          mb: 1,
          px: 1,
          color: '#333',
          textAlign: 'left',
        }}
      >
       Shop by Category
      </Typography>
        <Grid container  spacing={2}  sx={{ py: 2, my: 1 }}>
          {CATEGORIES.map(cat => (
            <Grid key={cat.title} size={{ xs: 6, sm: 4 }}>
              <Link to={`/products?category=${encodeURIComponent(cat.title)}`}>
                <CategoryCard {...cat} onClick={() => {/* goto products */}} />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Brands />
    </>

  )
}
